/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/**
 * Check if the event is Ctrl + V
 * @param {object} event 
 */
class A11YUtils {
	static isPaste(event) {
		return event.keyCode === 86 && (event.ctrlKey || event.metaKey);
	}
}

export default A11YUtils;


// WEBPACK FOOTER //
// ./src/js/lib/@waca/a11y/src/js/Utils.js